import {observer} from "mobx-react";
import React from "react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import  {FontBody2} from "../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import {Input} from "../../../../components/inputs/input/input";
import {DROPDOWN_MENU_WIDTH, SelectDropdown} from "../../../../components/inputs/select-dropdown/select-dropdown";
import {LABEL_POSITIONS, Toggle} from "../../../../components/inputs/toggle/toggle";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import {IValidationGroup} from "../../../../hooks/validation-group/validation-group-hook";
import {rootContainer, TYPE} from "../../../../services/container/root";
import CurrencyService from "../../../../services/currency-service";
import {AMOUNT_TYPE} from "../../../policies/policy-types";
import RmaFeeStore from "../../stores/rma-fee-store";
import RmaRequestStore from "../../stores/rma-request-store";
import currentPortalStore from "../../../../stores/current-portal-store";


interface IProps{
    store: RmaFeeStore;
    rmaRequestStore: RmaRequestStore;
    validationGroup: IValidationGroup;
    isPolicyLedMode: boolean;
}

const RmaReturnFee: React.FC<IProps> = observer(({store, rmaRequestStore, validationGroup, isPolicyLedMode})=>{
    const currencyService = rootContainer.get<CurrencyService>(TYPE.CurrencyService);
    
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-create-rma';
    const feeAmountTypeOptions = rmaRequestStore.feeAmountTypeOptions(store.feeType, getTranslation, scope);
    
    
    return (
        <>
		<div className={'line'}>
			<FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{getTranslation('RETURN_FEE', scope)}</FontBody1>
			<Toggle
                label=''
                labelPosition={LABEL_POSITIONS.LEFT}
                checked={store.isCharged}
                onChange={store.setCharged}
                disabled={isPolicyLedMode}
            />
		</div>
            {!!store.isCharged &&
             <div className={'indent'}>
				    <div className={'opened-editor'}>
                        {store.showAmountOptions && (
                            <>
							{store.hasEditableAmount ?
                             <SelectDropdown
                                 value={feeAmountTypeOptions.find(o => o.value === store.amountType)}
                                 options={feeAmountTypeOptions}
                                 menuWidth={DROPDOWN_MENU_WIDTH.MAX_CONTENT}
                                 onChange={(v) => v?.value && store.setAmountType(v.value as AMOUNT_TYPE)}
                                 required
                                 validationGroup={validationGroup}
                                 disabled={isPolicyLedMode}
                             /> :
                             <FontBody2>{getTranslation('FIXED_AMOUNT', scope)}</FontBody2>}
                                
                                {!store.hasPercentageAmount && currentPortalStore.setting?.currencyCode && currencyService.getCurrencySymbol(currentPortalStore.setting?.currencyCode)}
                                <Input
                                    value={store.amount}
                                    onChange={store.setAmount}
                                    type={'number'}
                                    min={0}
                                    required
                                    validationGroup={validationGroup}
                                    disabled={isPolicyLedMode}
                                />
                                {store.hasPercentageAmount && '%'}
						</>
                        )
                        }
                        <div className={'align-to-left'}>
                            <Toggle label={getTranslation('CHARGE_TAX', scope)}
                                    checked={store.isChargeTax}
                                    onChange={store.setIsChargeTax}
                                    labelPosition={LABEL_POSITIONS.LEFT}
                                    disabled={isPolicyLedMode}
                            >
                            </Toggle>
                        </div>
				</div>
                </div>
            }
		</>
    );
})

export default RmaReturnFee;